import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  LinearProgress,
  useTheme,
  alpha
} from '@mui/material';
import { BarChart3, Brain, TrendingUp } from 'lucide-react';

const LoadingState = ({ insuranceType }) => {
  const theme = useTheme();

  const steps = [
    { icon: <Brain size={20} />, text: "Analyzing customer data..." },
    { icon: <TrendingUp size={20} />, text: "Calculating risk factors..." },
    { icon: <BarChart3 size={20} />, text: "Generating commission scores..." }
  ];

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 4,
        overflow: 'hidden',
        boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
        border: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Box
        sx={{
          p: 3,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
        }}
      >
        <Typography variant="h5" fontWeight="700" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BarChart3 size={24} />
          {insuranceType} Analysis
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
          AI-powered commission scoring in progress...
        </Typography>
      </Box>
      
      <CardContent sx={{ p: 6, textAlign: 'center' }}>
        <Box sx={{ mb: 4 }}>
          <CircularProgress 
            size={60} 
            thickness={4}
            sx={{ 
              color: theme.palette.primary.main,
              mb: 3
            }} 
          />
          <Typography variant="h6" fontWeight="600" gutterBottom>
            Processing Your Request
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Our AI is analyzing the customer profile and generating commission scores...
          </Typography>
        </Box>

        <Box sx={{ maxWidth: 400, mx: 'auto' }}>
          {steps.map((step, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box sx={{ color: theme.palette.primary.main, mr: 2 }}>
                {step.icon}
              </Box>
              <Typography variant="body2" color="text.secondary">
                {step.text}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: 4 }}>
          <LinearProgress 
            sx={{ 
              height: 6, 
              borderRadius: 3,
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              '& .MuiLinearProgress-bar': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 3
              }
            }} 
          />
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            This usually takes 2-3 seconds
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default LoadingState;
